// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".second-row-card .title-row div {\n  margin-right: 305px;\n}\n.second-row-card .content-row .el-input-number {\n  margin-right: 145px;\n  width: 210px !important;\n}\n", ""]);
// Exports
module.exports = exports;
